export class FluentDate {
  private date: Date;

  constructor(date: Date | null = null) {
    this.date = date ? new Date(date.getTime()) : new Date();
  }

  public get value() {
    return this.date;
  }

  public startOfYear() {
    this.date.setUTCMonth(0, 1);
    this.date.setUTCHours(0, 0, 0, 0);
    return this;
  }

  public startOfMonth() {
    this.date.setUTCDate(1);
    this.date.setUTCHours(0, 0, 0, 0);
    return this;
  }

  public endOfMonth() {
    this.date.setUTCDate(1);
    this.date.setUTCMonth(this.date.getUTCMonth() + 1);
    this.date.setUTCDate(0);
    this.date.setUTCHours(23, 59, 59, 999);
    return this;
  }

  public endOfYear() {
    this.date.setUTCMonth(11, 31);
    this.date.setUTCHours(23, 59, 59, 999);
    return this;
  }

  public startOfDay() {
    this.date.setUTCHours(0, 0, 0, 0);
    return this;
  }

  public endOfDay() {
    this.date.setUTCHours(23, 59, 59, 999);
    return this;
  }

  public addDays(days: number) {
    this.date.setUTCDate(this.date.getDate() + days);
    return this;
  }

  public addMonths(months: number) {
    this.date.setUTCMonth(this.date.getMonth() + months);
    return this;
  }

  public subtractDays(days: number) {
    this.date.setUTCDate(this.date.getDate() - days);
    return this;
  }

  public subtractMonths(months: number) {
    this.date.setUTCMonth(this.date.getMonth() - months);
    return this;
  }

  public subtractYears(years: number) {
    this.date.setUTCFullYear(this.date.getFullYear() - years);
    return this;
  }

  public isStartOfMonth() {
    return this.date.getTime() === new Date(this.date.getFullYear(), this.date.getMonth(), 1).getTime();
  }

  public isEndOfMonth() {
    return (
      this.date.getTime() === new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0, 23, 59, 59, 999).getTime()
    );
  }
}
